function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGoogle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.64 9.2a10.341 10.341 0 0 0-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.8 2.716v2.264h2.909A8.777 8.777 0 0 0 17.64 9.2z",
    style: {
      fillRule: "evenodd",
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M9 18a8.592 8.592 0 0 0 5.956-2.18l-2.909-2.258a5.43 5.43 0 0 1-8.083-2.852H.957v2.332A9 9 0 0 0 9 18z",
    style: {
      fill: "#34a853",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M3.964 10.71a5.321 5.321 0 0 1 0-3.42V4.958H.957a9.011 9.011 0 0 0 0 8.084l3.007-2.332z",
    style: {
      fill: "#fbbc05",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M9 3.58a4.862 4.862 0 0 1 3.44 1.346l2.581-2.581A8.649 8.649 0 0 0 9 0 9 9 0 0 0 .957 4.958L3.964 7.29A5.364 5.364 0 0 1 9 3.58z",
    style: {
      fill: "#ea4335",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M0 0h18v18H0z",
    style: {
      fill: "none",
      fillRule: "evenodd"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google.6343d6b6.svg";
export { ForwardRef as ReactComponent };